const BLOCKED_EMAIL_DOMAINS = process.env.REACT_APP_BLOCKED_EMAIL_DOMAINS
  ?.split(",")
  .map((d) => d.trim().toLowerCase()) || [];

export const isBlockedEmailDomain = (email) => {
  // handle the email validations before utilizing this.
  if (!email) return false;
  const domain = email.trim().toLowerCase().split("@")[1];

  return BLOCKED_EMAIL_DOMAINS.some(blocked =>
    domain === blocked || domain.endsWith(`.${blocked}`)
  );
};

export const checkEmailRegex = (email) => {
  if (!email) return false;

  const normalized = email.trim().toLowerCase();
  const emailRegex =
    /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
  return emailRegex.test(normalized);

};